define(["site/TEKsystems.SitecoreXP.Analytics"], function (analytics) {
   return function initClickableHighlight(args) {
     if (args.track) {
      const scopeElement = args.scope;
      if (scopeElement) {
        const titleElement = scopeElement.querySelector("h2"); 
        const urlElement = scopeElement.querySelector("a");
        const titleText = titleElement ? titleElement.innerText : "";
        if (urlElement) {
          const urlDestination = urlElement.href || "";
          urlElement.addEventListener("mousedown", () => {
            analytics.registerClick(urlDestination, titleText, args.itemId);
          });
        } 
      } 
    }
   }
});
